import { IUseBackendSync } from '@axo/form/data-access/backend-sync';
import type { customer as IDataCustomer } from '@axo/shared/data-access/types';
import { useAnalytics } from '@axo/shared/services/analytics';
import { useEffect, useState } from 'react';

type ICustomer = Required<
  Pick<
    IDataCustomer.Customer,
    'ID' | 'Email' | 'MobilePhoneCountryCode' | 'MobilePhoneNumber'
  >
>;

export const useCustomerAnalytics = ({
  data,
}: {
  data: IUseBackendSync<any>;
}) => {
  const [customer, setCustomer] = useState<ICustomer | null>(null);
  const { identify, reset } = useAnalytics();

  useEffect(() => {
    if (data.initialized && !data.isLoading) {
      const {
        customerId,
        customerEmail,
        customerMobilePhoneCountryCode,
        customerMobilePhoneNumber,
      } = data.getPreconditions();

      if (customerId) {
        setCustomer({
          ID: customerId,
          Email: customerEmail ?? '',
          MobilePhoneCountryCode: customerMobilePhoneCountryCode ?? 0,
          MobilePhoneNumber: customerMobilePhoneNumber ?? '',
        });
      }
    }
  }, [data.initialized, data.isLoading]);

  useEffect(() => {
    customer
      ? identify({
          uuid: customer.ID,
          email: customer.Email,
          phonenumber: `+${customer.MobilePhoneCountryCode}${customer.MobilePhoneNumber}`,
        })
      : reset();
  }, [customer, customer?.ID]);
};
